/* HB — One preference for the storefront and its embedded HB pages. */
(() => {
  'use strict';
  if (window.HBColorMode) return;
  const configNode = document.getElementById('hb-color-config');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const key = 'hb-color-mode-v1';
  const root = document.documentElement;
  const system = matchMedia('(prefers-color-scheme: light)');
  const hosts = new Set();
  const mobileHeader = matchMedia('(max-width:749px)');
  const boundButtons = new WeakSet();
  let choice;
  try { choice = localStorage.getItem(key); } catch (_) { /* Optional persistence. */ }
  const valid = value => value === 'light' || value === 'dark';
  if (!valid(choice)) choice = null;
  const resolve = () => choice || (config.defaultMode === 'system' ? (system.matches ? 'light' : 'dark') : config.defaultMode === 'light' ? 'light' : 'dark');
  const icons = '<svg class="hb-color-toggle__sun" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="4"/><path d="M12 2v2m0 16v2M2 12h2m16 0h2M5 5l1.4 1.4m11.2 11.2L19 19M5 19l1.4-1.4M17.6 6.4L19 5"/></svg><svg class="hb-color-toggle__moon" viewBox="0 0 24 24" aria-hidden="true"><path d="M20.4 15.2A8.8 8.8 0 0 1 8.8 3.6a8.8 8.8 0 1 0 11.6 11.6Z"/></svg>';

  function syncButtons() {
    const mode = root.dataset.hbColorMode;
    document.querySelectorAll('[data-hb-color-toggle]').forEach(button => {
      const label = mode === 'dark' ? 'Passer en mode clair' : 'Passer en mode sombre';
      button.setAttribute('aria-label', label);
      button.title = label;
      button.dataset.mode = mode;
    });
  }

  function syncHost(host) {
    if (!host.isConnected) { hosts.delete(host); return; }
    const content = host.shadowRoot?.querySelector('#hbui-inline-content');
    if (!content) return;
    content.dataset.hbColorMode = root.dataset.hbColorMode;
    content.style.colorScheme = root.dataset.hbColorMode;
    const parent = host.closest('hb-univers-interactif');
    if (parent && parent.dataset.embeddedDesign !== 'false') {
      const style = getComputedStyle(parent);
      ['bg', 'panel', 'accent', 'ink'].forEach(name => {
        host.style.setProperty('--hb-embedded-' + name, style.getPropertyValue('--' + name).trim());
      });
    }
  }

  function registerShadow(host) {
    const shadow = host.shadowRoot;
    if (!shadow || !shadow.querySelector('#hbui-inline-content')) return;
    if (!shadow.querySelector('[data-hb-color-styles]')) {
      const link = document.createElement('link');
      link.rel = 'stylesheet'; link.href = config.stylesheet;
      link.dataset.hbColorStyles = '';
      shadow.append(link);
    }
    hosts.add(host);
    syncHost(host);
  }

  function apply() {
    const mode = resolve();
    root.dataset.hbColorMode = mode;
    root.style.colorScheme = mode;
    syncButtons();
    hosts.forEach(syncHost);
    document.dispatchEvent(new CustomEvent('hb:color-mode', { detail: { mode } }));
  }

  function setMode(mode) {
    if (!valid(mode)) return;
    choice = mode;
    try { localStorage.setItem(key, mode); } catch (_) { /* Continue in this page. */ }
    apply();
  }

  function scan(node) {
    if (!(node instanceof Element) && node !== document) return;
    const headers = new Set(node.querySelectorAll('hb-global-header'));
    const owner = node.closest?.('hb-global-header');
    if (owner) headers.add(owner);
    headers.forEach(header => {
      const mobileSlot = header.querySelector('[data-hbg-mobile-theme]');
      const container = (mobileHeader.matches && mobileSlot) || header.querySelector('.hbg-actions');
      if (!container) return;
      let button = header.querySelector('[data-hb-color-toggle]');
      if (!button) {
        button = document.createElement('button');
        button.type = 'button'; button.className = 'hb-color-toggle';
        button.dataset.hbColorToggle = ''; button.innerHTML = icons;
      }
      if (!boundButtons.has(button)) {
        button.addEventListener('click', () => setMode(root.dataset.hbColorMode === 'dark' ? 'light' : 'dark'));
        boundButtons.add(button);
      }
      if (button.parentElement !== container) container.prepend(button);
    });
    const embedded = [...node.querySelectorAll('.hbui-inline-page')];
    if (node.matches?.('.hbui-inline-page')) embedded.push(node);
    embedded.forEach(registerShadow);
    syncButtons();
  }

  window.HBColorMode = { setMode, registerShadow, get mode() { return root.dataset.hbColorMode; } };
  function start() {
    scan(document); apply();
    new MutationObserver(records => {
      records.forEach(record => record.addedNodes.forEach(scan));
      hosts.forEach(host => { if (!host.isConnected) hosts.delete(host); });
    }).observe(document.body, {childList:true, subtree:true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
  window.addEventListener('storage', event => {
    if (event.key !== key && event.key !== null) return;
    choice = valid(event.newValue) ? event.newValue : null;
    apply();
  });
  mobileHeader.addEventListener('change', () => scan(document));
  system.addEventListener('change', () => { if (!choice && config.defaultMode === 'system') apply(); });
  window.addEventListener('pageshow', () => {
    try { const saved = localStorage.getItem(key); choice = valid(saved) ? saved : null; } catch (_) {}
    apply();
  });
})();
